/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_Is_Broken_HintInputs */

const vi_tea_grade_is_broken_hint = /** @type {(inputs: Tea_Grade_Is_Broken_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại chè tấm chỉ hiện ở cột Chè tấm của sổ lấy hương.`)
};

/**

* @param {Tea_Grade_Is_Broken_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_is_broken_hint = /** @type {((inputs?: Tea_Grade_Is_Broken_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Is_Broken_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_is_broken_hint(inputs)
});